import { CloseCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Avatar, FloatButton, Select, Space, Spin } from "antd";
import { List, Toast, Tag, Popup, Tabs, Dialog } from "antd-mobile";
import axios from "axios";
import $ from "jquery";
import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { MOB_ICONS, customSorting, groupByMultiple } from "../../utils";
const { Option } = Select;
import moment from "moment";
import { TIME_PERMISSION_SORT_ORDER, NON_TIME_PERMISSION_SORT_ORDER } from "../../utils/data";
import PsContext from "../../context";
import { getFileLiveUrl, jsonToQuery, momentDate } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import PermissionSubstitute from "./permissionSubstitute";

const Permission = (props) => {
  const context = useContext(PsContext);


  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [showView, setShowView] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [oldFile, setOldFile] = useState("");
  const [showList, setShowList] = useState(true);
  const [substituteLeaves, setSubstituteLeaves] = useState([]);
  const [substituteStatus, setSubstituteStatus] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [activeTab, setActiveTab] = useState("mypermission");
  const [showListView, setShowListView] = useState(false);
  const [selectedSortOrder, setSelectedSortOrder] = useState(null);
  const [sortOrderOptions, setSortOrderOptions] = useState([]);
  const [sortOrderOptionsNonteaching, setSortOrderOptionsfornonteaching] = useState([]);
  const [fromTime, setFromTime] = useState("");
  const [toTime, setToTime] = useState("");
  const [showSubstitute, setShowSubstitute] = useState(false);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 50,
    },
    total: 0,
  });
  const [staffDetails, setStaffDetails] = useState([]);
  const [fromDate, setFromDate] = useState(
    momentDate(new Date(), "YYYY-MM-DD")
  );
  useEffect(() => {
    if (!loader) getReport();
  }, [JSON.stringify(tableParams.pagination)]);
  const getRandomuserParams = (params) => ({
    limit: params.pagination?.pageSize,
    page: params.pagination?.current,
    name: params.pagination?.name,
    from_date: params.pagination?.from_date,
    to_date: params.pagination?.to_date,
  });
  useEffect(() => {
    setSortOrderOptions(TIME_PERMISSION_SORT_ORDER);
    setSortOrderOptionsfornonteaching(NON_TIME_PERMISSION_SORT_ORDER);


  }, []);
  useEffect(() => { }, [sortOrderOptions]);
  useEffect(() => {
    if (props.profilePhoto) setOldFile(props.profilePhoto);
  }, [props.profilePhoto]);


  const getReport = () => {
    setLoader(true);
    setDataList([]);
    setDataView([]);
    const form = new FormData();

    axios
      .post(
        ServiceUrl.MOB.EMP_PERMISSION_LIST +
        "?" +
        jsonToQuery(getRandomuserParams(tableParams)) +
        "&emp_id=" +
        context.user.id
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
          setDataView(res["data"].data);
          setTableParams({
            ...tableParams,
            pagination: {
              ...tableParams.pagination,
              total: res["data"].count,
            },
          });

          setSubstituteLeaves(res["data"].substitude_leaves);
          setSubstituteStatus(res["data"].substitude_approval);

        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        setLoader(false);
      });
  };


  const sortOrderOptionsToUse =
    context.user.emp_employee_category === 1 || !context.user.emp_employee_category
      ? TIME_PERMISSION_SORT_ORDER
      : NON_TIME_PERMISSION_SORT_ORDER;

  // const handleSelectChange = (value) => {
  //   setSelectedSortOrder(value);
  // };

  const handleView = (item) => {
    setShowView(item);
  };
  const formatTimes = (time) => {
    return moment(time, "HH:mm:ss").format("h A");
  };
  const handleFormSubmit = (e) => {
    e.preventDefault();
    setLoader(true);

    if ($("#request_staffs").val() == "[]") {
      Toast.show({
        content: "Please Select substitute staff",
      });
      return;
    }
    Toast.show("Processing...");

    const form = new FormData();
    form.append("emp_id", context.user.id);
    axios
      .post(ServiceUrl.MOB.EMP_PERMISSION_SAVE, $("#frm_add").serialize())
      .then((res) => {
        if (res["data"].status == "1") {
          Toast.show({ content: res["data"].message || "Saved" });
          setShowList(true);

          setShowForm(false);
          getReport();
          setLoader(false);
          document.getElementById("frm_add").reset();
        } else {
          Toast.show({ content: res["data"].message || "Error" });
          setLoader(false);
        }
      });
  };
  const handleSelectChange = (value) => {
    setSelectedSortOrder(value);
    const [from, to] = value.split("-");
    const formattedFrom = formatTime(from.trim());
    const formattedTo = formatTime(to.trim());
    setFromTime(formattedFrom);
    setToTime(formattedTo);
  };
  const formatTime = (timeString) => {
    const timeParts = timeString.match(/(\d{1,2})\s*(AM|PM)/);
    if (timeParts) {
      let [_, hours, period] = timeParts;
      hours = parseInt(hours, 10);
      if (period === "PM" && hours !== 12) {
        hours += 12;
      }
      if (period === "AM" && hours === 12) {
        hours = 0;
      }
      const formattedHours = hours < 10 ? `0${hours}` : hours;
      return `${formattedHours}:00:00`;
    }
    return "00:00:00";
  };
  function handleApprovalSubstitude(type, item) {
    const form = new FormData();
    form.append("id", item.id);
    // console.log(context);
    if (type == "approved") {
      Dialog.confirm({
        title: "Do you want to approve ?",
        confirmText: "Yes",
        cancelText: "Cancel",

        onConfirm: () => {
          Toast.show("Processing...");
          form.append("substitute_status", 1);
          axios
            .post(ServiceUrl.MOB.EMP_SUBSTITUTE_PERMISSION_APPROVAL, form)
            .then((res) => {
              if (res["data"].status == "1") {
                Toast.show({ content: res["data"].message || "Approved" });
                getReport();
              } else {
                Toast.show({ content: res["data"].message || "Error" });
              }
            });
        },
      });
    } else {
      Dialog.confirm({
        title: "Do you want to reject?",
        confirmText: "Yes",
        cancelText: "Cancel",
        onConfirm: () => {
          Toast.show("Processing...");
          form.append("substitute_status", 2);
          axios
            .post(ServiceUrl.MOB.EMP_SUBSTITUTE_PERMISSION_APPROVAL, form)
            .then((res) => {
              if (res["data"].status == "1") {
                Toast.show({ content: res["data"].message || "Rejected" });
                getReport();
              } else {
                Toast.show({ content: res["data"].message || "Error" });
              }
            });
        },
      });
    }
  }
  return (
    <>
      <div className="page-content-wrapper">
        <div className=" py-3">
          <section className="top-space pt-0 pb-0">
            <Header title="Permission Request" backAction={true} rightActions={[]} />
            <div className="container leave">
              <Tabs
                className="bg-white"
                activeKey={activeTab}
                onChange={(k) => setActiveTab(k)}
              >
                <Tabs.Tab title={<>My Permission</>} key="mypermission" />

                <Tabs.Tab title={<>Substitute Request</>} key="substitutestaff" />
              </Tabs>
            </div>

            <Spin spinning={loader}>
              {showList && activeTab == "mypermission" && (
                <div>
                  <div className="container">
                    <Card className="mb-2">

                      <Card.Header style={{ position: "relative" }}>
                        <h6>Permission </h6>
                        <FloatButton
                          icon={<img src={MOB_ICONS.ADD_BUTTON} />}
                          type="default"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "absolute",
                            top: "50%",
                            right: 24,
                            transform: "translateY(-50%)",
                            width: "32px",
                            height: "32px",
                          }}
                          onClick={() => {
                            setShowList(false);

                            setShowForm(true);
                          }}
                        />
                      </Card.Header>
                      <Card.Body className="fs-6">
                        <br />
                        <List>
                          {dataView.map((item) => (
                            <List.Item
                              key={item.company_name}
                              prefix={
                                <Avatar
                                  style={{
                                    backgroundColor: "#f56a00",
                                    verticalAlign: "middle",
                                    textTransform: "uppercase",
                                  }}
                                  size="large"
                                >
                                  {parseInt(item.approved) ? "A" : "W"}
                                </Avatar>
                              }
                              onClick={(e) => {
                                handleView(item);
                                setShowList(false);
                                setShowForm(false);
                                setShowListView(true);
                              }}
                            >
                              <Space size={[0, 8]} wrap>
                                {item.approved === "2" && (
                                  <Tag color="red">Rejected</Tag>
                                )}
                                {item.approved === "1" && (
                                  <Tag color="green">Approved</Tag>
                                )}
                                {item.approved === "0" && (
                                  <Tag color="orange">Pending</Tag>
                                )}
                              </Space>&nbsp; &nbsp;
                              {momentDate(item.date, "DD-MM-YYYY")}
                              <br />
                              {formatTimes(item.from_time)} -{" "}
                              {formatTimes(item.to_time)}
                            </List.Item>
                          ))}
                        </List>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              )}
              {activeTab == "substitutestaff" && (
                <div>
                  <div className="container staff">
                    <Card className="mb-2">
                      <Card.Header
                        style={{
                          position: "relative",
                          background: " #fff",
                          paddingTop: "15px",
                        }}
                      >
                        <h6>SUBSTITUTE REQUEST APPROVAL </h6>
                      </Card.Header>
                      <Card.Body className="fs-6">
                        <table>
                          <thead>
                            <tr>
                              <th scope="col">Name</th>
                              <th scope="col">Subject</th>
                              <th scope="col">Hour</th>
                              <th scope="col">Day Order</th>
                              <th scope="col">Date</th>
                              <th scope="col">Approval</th>
                            </tr>
                          </thead>
                          <tbody>
                            {substituteLeaves &&
                              substituteLeaves.length > 0 &&
                              substituteLeaves.map((item) => (
                                <tr>
                                  <td data-label="Name">{item.emp_name}</td>
                                  <td data-label="Subject">
                                    {item.substitute_subject_name}
                                  </td>
                                  <td data-label="Hour">{item.substitute_hour}</td>
                                  <td data-label="Day Order">
                                    {item.substitute_dayorder}
                                  </td>
                                  <td data-label="Date">
                                    {" "}
                                    {momentDate(
                                      item.leave_request_date,
                                      "DD/MM/YYYY"
                                    )}
                                  </td>
                                  <td data-label="Approval">
                                    {item.substitute_status != null &&
                                      (item.substitute_status == 1 ? (
                                        <>
                                          <img
                                            src={MOB_ICONS.APPROVED}
                                            style={{ width: "60%" }}
                                          />
                                        </>
                                      ) : (
                                        <>
                                          <img
                                            src={MOB_ICONS.REJECTED}
                                            style={{ width: "60%" }}
                                          />
                                        </>
                                      ))}

                                    {item.substitute_status == null ? (
                                      <>
                                        <a
                                          onClick={(e) =>
                                            handleApprovalSubstitude("approved", item)
                                          }
                                        >
                                          <img
                                            src={MOB_ICONS.ACCEPT_BUTTON}
                                            style={{ width: "60%" }}
                                          />
                                        </a>
                                        &nbsp;
                                        <a
                                          onClick={(e) =>
                                            handleApprovalSubstitude("rejected", item)
                                          }
                                        >
                                          <img
                                            src={MOB_ICONS.REJECT_BUTTON}
                                            style={{ width: "60%" }}
                                          />
                                        </a>{" "}
                                        <br />
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              )}
              {showForm && (
                <div className="page-content-wrapper">
                  <div className="container">
                    <Card className="mb-2">
                      <Card.Header style={{ position: "relative", padding: "3%" }}>
                        <h6>Add Permission Request </h6>
                        <FloatButton
                          icon={
                            <CloseCircleOutlined style={{ verticalAlign: "3px" }} />
                          }
                          type="default"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "absolute",
                            top: "50%",
                            right: 24,
                            transform: "translateY(-50%)",
                            width: "32px",
                            height: "32px",
                          }}
                          onClick={() => {
                            setShowForm(false);
                            setShowList(true);
                          }}
                        />
                      </Card.Header>
                      <Card.Body>
                        <Form
                          method="post"
                          noValidate
                          // validated={validated}
                          id="frm_add"
                          onSubmit={handleFormSubmit}
                        >
                          <input type="hidden" name="emp_id" value={context.user.id} />
                          <input
                            type="hidden"
                            name="emp_code"
                            value={context.user.emp_code}
                          />
                          <input
                            type="hidden"
                            name="emp_name"
                            value={context.user.emp_name}
                          />
                          <input
                            type="hidden"
                            name="emp_permisision_form"
                            value="mobile"
                          />
                          <input
                            type="hidden"
                            name="request_staffs"
                            id="request_staffs"
                            value={JSON.stringify(staffDetails)}
                          />
                          <input type="hidden" name="from_time" value={fromTime} />
                          <input type="hidden" name="to_time" value={toTime} />
                          <input type="hidden" name="total_hours" value="1" />
                          <Row>
                            <Col md={4}>
                              <label className="fs-sm">
                                Date <span className="text-danger">*</span>
                              </label>
                            </Col>
                            <Col md={4}>
                              <Form.Control
                                type="date"
                                name="date"
                                className="fw-bold mt-2"
                                onChange={(e) => {
                                  setFromDate(e.target.value);
                                }}
                                value={fromDate}
                                size="sm"
                                required
                              />
                            </Col>
                          </Row>
                          <Row className="mt-2">
                            <Col md={5}>
                              <FloatButton
                                icon={<img src={MOB_ICONS.ADD_BUTTON} />}
                                type="default"
                                shape="square"
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  position: "absolute",
                                  top: "43%",
                                  right: 16,
                                  transform: "translateY(-50%)",
                                  width: "115px",
                                  height: "33px",
                                }}
                                description="Add Substitute Staff"
                                onClick={(e) => setShowSubstitute(true)}
                              />{" "}
                            </Col>
                          </Row>

                          <Row className="mt-2">
                            <Col md={4}>
                              <label className="fs-sm">
                                {" "}
                                Permission On <span className="text-danger">*</span>
                              </label>
                            </Col>
                            {/* <Col md={4}>
                              <Select
                                className="fw-bold mt-2"
                                size="sm"
                                value={selectedSortOrder}
                                onChange={handleSelectChange}
                                placeholder="Select Time Slot"
                              >
                                {TIME_PERMISSION_SORT_ORDER.map((option, index) => (
                                  <Option key={index} value={option}>
                                    {option}
                                  </Option>
                                ))}
                              </Select>
                            </Col> */}
                            <Col md={4}>
                              <Select
                                className="fw-bold mt-2"
                                size="sm"
                                value={selectedSortOrder}
                                onChange={handleSelectChange}
                                placeholder="Select Time Slot"
                              >
                                {sortOrderOptionsToUse.map((option, index) => (
                                  <Option key={index} value={option}>
                                    {option}
                                  </Option>
                                ))}
                              </Select>
                            </Col>
                          </Row>

                          <Row>
                            <Col md={4}>
                              <label className="fs-sm"> Reason</label>
                            </Col>
                            <Col md={4}>
                              <Form.Control
                                type="text"
                                name="reason"
                                className="fw-bold mt-2"
                                size="md"
                              />
                            </Col>
                          </Row>

                          <Row className="mt-2">
                            <Col md={2}></Col>
                            <Col md={10}>
                              <div className="text-end">
                                <Button
                                  type="reset"
                                  size="sm"
                                  variant="danger"
                                  className="me-2"
                                >
                                  <i className="fa fa-xmark me-2 pe-2 border-right"></i>
                                  Reset
                                </Button>
                                <Button type="submit" size="sm" variant="secondary">
                                  <i className="fa fa-check me-2 pe-2 border-right"></i>
                                  Save
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        </Form>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              )}

              {showListView && (
                <div>
                  <div className="container">
                    <Card className="mb-2">
                      <Card.Header style={{ position: "relative" }}>
                        <h6> VIEW PERMISSION </h6>
                        <FloatButton
                          icon={<img src={MOB_ICONS.CLOSE_BUTTON} />}
                          type="default"
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "absolute",
                            top: "50%",
                            right: 24,
                            transform: "translateY(-50%)",
                            width: "32px",
                            height: "32px",
                          }}
                          onClick={() => {
                            setShowListView(false);
                            setShowList(true);
                          }}
                        />
                      </Card.Header>
                      <Card.Body>
                        <div style={{ display: "" }}>
                          <div id="view">
                            <table
                              width="100%"
                              align="center"
                              className="font-bookman"
                              cellPadding={3}
                            >
                              <thead>
                                {context.settingValue("billheader_name") ? (
                                  <>
                                    {" "}
                                    <tr align="center">
                                      <th colSpan={3} align="center" height="30">
                                        <b>{context.settingValue("billheader_name")}</b>
                                      </th>
                                    </tr>
                                  </>
                                ) : (
                                  ""
                                )}
                              </thead>
                              <tbody>
                                <tr>
                                  <td width="30%">Date</td>
                                  <td align="center" width="10%">
                                    :
                                  </td>
                                  <td width="70%">
                                    {" "}
                                    {momentDate(showView.date, "DD-MM-YYYY")}
                                  </td>
                                </tr>
                                <tr>
                                  <td width="30%">Permission On</td>
                                  <td align="center" width="10%">
                                    :
                                  </td>
                                  <td width="70%">
                                    {" "}
                                    {formatTimes(showView.from_time)} -{" "}
                                    {formatTimes(showView.to_time)}
                                  </td>
                                </tr>

                                <tr>
                                  <td width="30%"> Reason</td>
                                  <td align="center" width="10%">
                                    :
                                  </td>
                                  <td width="70%"> {showView.reason}</td>
                                </tr>
                                <tr>
                                  <td width="30%"> Permission Status</td>
                                  <td align="center" width="10%">
                                    :
                                  </td>
                                  <td width="70%">
                                    {" "}
                                    {showView.approved == 1 ? "Approved" : "Waiting"}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                </div>
              )}
            </Spin>
          </section>
          <section className="top-space "></section>
        </div>
      </div>
      <Popup
        visible={showSubstitute}
        direction="vertical"
        position="top"
        bodyStyle={{ height: "80vh", overflowY: "scroll" }}
        showCloseButton={true}
        onMaskClick={() => {
          setShowSubstitute(false);
        }}
        onClose={() => {
          setShowSubstitute(false);
        }}
      >
        <div className="px-2 py-3">
          {" "}
          <PermissionSubstitute
            fromDate={fromDate}
            toDate={fromDate}
            staff_id={context.user.id}
            day={selectedSortOrder}
            onSuccess={(data) => {
              setStaffDetails(data);
              setShowSubstitute(false);
            }}
          />
        </div>
      </Popup>
    </>
  );
};
export default Permission;
